/**
 * Created by vladislav on 03.03.2020
 */

const BeforeLoseWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this.game = Game.currentGame;

        this._super({
            name: "loseroundwindow",
            title: Messages.get("LoseRoundWindow.title"),
            content: this.getContent(),
            button: {
                text: Messages.get("OK"),
                onClick: function () {
                    this.close();
                }.bind(this)
            }
        });
    },

    getContent: function () {
        const styles = cleverapps.styles.LoseRoundWindow;

        const roundResults = new RoundResultsComponent(cleverapps.knockoutGame.rumble.getCurrentRound());

        const list = new WordsListComponent({
            words: this.game.board.getUndiscoveredWords(),
            width: styles.list.width,
            height: styles.list.height,
            minimalWordsAmount: 8
        });

        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(Messages.get("BeforeLoseWindow.words"), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.fitTo(styles.text.width);

        const wordsLayout = new cleverapps.Layout([text, list], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.text.margin
        });

        return new cleverapps.Layout([roundResults, wordsLayout], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: styles.padding
        });
    }
});

cleverapps.styles.LoseRoundWindow = {
    margin: 60,

    text: {
        width: 500,
        margin: 10
    },

    padding: {
        top: 40
    },

    list: {
        height: 306,
        width: 300
    },

    roundResults: {
        x: { align: "center" },
        y: { align: "center" }
    }
};